//@flow
import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles, Button} from '@material-ui/core';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import {colors} from '../../../../../assets/styles/colors';
import {Add} from '@material-ui/icons';
import {
  useStoreLocations,
  useStoreLocationActions,
} from '../../../utils/location';

import StoreLocationItem from './LocationItem';

const useStyles = makeStyles(theme => ({
  addBannerButton: {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: colors.grey500,
    border: `2px dashed ${colors.grey500}`,
    borderRadius: '.75rem',
    paddingBlock: '.85rem',
  },
  bannerList: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      borderBottom: `1px solid ${colors.grey300}`,
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
  caption: {
    color: colors.grey500,
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: '1rem',
    display: 'block',
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function Locations(props: Props) {
  const {sectionEnabled} = props;

  const classes = useStyles();
  const {loading, locations, refreshLocations} = useStoreLocations();
  const {
    deleteStoreLocation,
    updateStoreLocation,
    loading: updating,
  } = useStoreLocationActions();

  const emptyContent = !(
    locations.length > 0 && locations.some(p => p.enabled)
  );

  return (
    <SwitchableSection
      title="Ubicaciones"
      subtitle="Crea hasta 3 ubicaciones para tu servicio"
      id={HOME_PAGE_SECTION_NAMES.STORE_LOCATION}
      classes={{
        //$FlowFixMe
        root: (emptyContent || !sectionEnabled) && classes.disabledRoot,
      }}
      loading={loading || updating}
    >
      <span className={classes.caption}>
        Hay {locations.length} ubicaciones activas
      </span>

      <div className={classes.bannerList}>
        {locations.map(location => (
          <StoreLocationItem
            location={location}
            key={location.id}
            onDelete={() => {
              deleteStoreLocation(location.id).then(() => {
                refreshLocations();
              });
            }}
            onToggleEnabled={() => {
              updateStoreLocation(location.id, {
                enabled: !location.enabled,
              }).then(() => {
                refreshLocations();
              });
            }}
          />
        ))}
      </div>

      <Button
        fullWidth
        className={classes.addBannerButton}
        component={Link}
        to="/my-store/pages/home-page/location/new"
      >
        <Add />
        Agregar Ubicación
      </Button>
    </SwitchableSection>
  );
}
